// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"117":"lightgallery-styles","122":"lightgallery-app-styles","230":"webinars-page"}[chunkId] + "." + {"117":"2a0f7ecc","122":"4733fe48","230":"12d8ebfa"}[chunkId] + ".css";
};